<template>
    <v-select :options="products" :reduce="name => name.id" label="name"/>
</template>

<script>
import { computed, onMounted } from '@vue/runtime-core';
import vSelect from 'vue-select';
import { useStore } from 'vuex';

export default {
    components: {
        vSelect
    },
    props: {
        merchantid: String,
        branchid: String,
    },
    setup(props) {
        const store = useStore();
        const products = computed(() => store.state.Product.products);

        onMounted(() => {
            loadProduct();
        });

        const loadProduct = async () => {
            let filter = {
                id: props.branchid,
            }

            if (props.merchantid) {
                filter = {
                    id: props.merchantid,
                }
            }

            await store.dispatch('Product/all', filter.id);
        }

        // const loadProduct = () => {
        //     let filter = {
        //         branch_id: props.branchid,
        //     }

        //     if (props.merchantid) {
        //         filter = {
        //             merchant_id: props.merchantid,
        //         }
        //     }

        //     store.commit('Product/add_filter', {filter});
        //     store.dispatch('Product/read');
        // };

        return {
            products,
        }
    }
}
</script>